import * as React from 'react'
import { TaskDescriptionEditorConnected } from './TaskDescriptionEditorConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const TaskDescriptionEditorExamples = () => {
  return (
    <div className="TaskDescriptionEditorExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <TaskDescriptionEditorConnected />
      </Provider>
    </div>
  )
}
